import api from './api'

const imageBasePath = '/api/v1/image'

export async function createImage(formData) {
  const resp = await api.post(`${imageBasePath}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return resp.data
}

export async function deleteImage() {
  const resp = await api.delete(`${imageBasePath}`)
  return resp.data
}
